export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '蜜仆'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '蜜仆-控制台'
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '蜜仆-控制台'
            },
          },
          
          {
            path: 'taskAgents',//待办任务
            name: 'taskAgents',
            component: () => import('@/views/main/taskAgents/index'),
            meta: {
              title: '蜜仆-待办任务'
            },
          },
          {
            path: 'contentAudit',//内容审核
            name: 'contentAudit',
            component: () => import('@/views/main/contentAudit/index'),
            meta: {
              title: '蜜仆-内容审核'
            },
          },
          {
            path: 'userManage',//用户管理
            name: 'userManage',
            component: () => import('@/views/main/userManage/index'),
            meta: {
              title: '蜜仆-用户管理'
            },
          },
          {
            path: 'userAduit',//用户管理
            name: 'userAduit',
            component: () => import('@/views/main/userManage/aduit'),
            meta: {
              title: '蜜仆-用户审核'
            },
          },
          {
            path: 'userBlack',//用户管理
            name: 'userBlack',
            component: () => import('@/views/main/userManage/black'),
            meta: {
              title: '蜜仆-用户审核'
            },
          },
          {
            path: 'tanguo',//糖果数据
            name: 'tanguo',
            component: () => import('@/views/main/userManage/tanguo'),
            meta: {
              title: '蜜仆-糖果数据'
            },
          },
          {
            path: 'dynamic',//动态管理
            name: 'dynamic',
            component: () => import('@/views/main/dynamic/index'),
            meta: {
              title: '蜜仆-动态管理'
            },
          },
          {
            path: 'wxPayManage',//支付管理
            name: 'wxPayManage',
            component: () => import('@/views/main/payManage/wxIndex'),
            meta: {
              title: '蜜仆-支付管理'
            },
          },
          {
            path: 'zfbPayManage',//支付管理
            name: 'zfbPayManage',
            component: () => import('@/views/main/payManage/zfbIndex'),
            meta: {
              title: '蜜仆-支付管理'
            },
          },
          {
            path: 'iosPayManage',//支付管理
            name: 'iosPayManage',
            component: () => import('@/views/main/payManage/iosIndex'),
            meta: {
              title: '蜜仆-支付管理'
            },
          },

          {
            path: 'payData',//统计支付
            name: 'payData',
            component: () => import('@/views/main/payManage/payData'),
            meta: {
              title: '蜜仆-统计支付'
            },
          },
          {
            path: 'withdrawal',//提现管理
            name: 'withdrawal',
            component: () => import('@/views/main/withdrawal/index'),
            meta: {
              title: '蜜仆-提现管理'
            },
          },
          {
            path: 'invite',//邀请管理
            name: 'invite',
            component: () => import('@/views/main/withdrawal/invite'),
            meta: {
              title: '蜜仆-邀请管理'
            },
          },
          {
            path: 'unlockList',//交换记录
            name: 'unlockList',
            component: () => import('@/views/main/payManage/unlockList'),
            meta: {
              title: '蜜仆-交换记录'
            },
          },
          {
            path: 'informationManage',//信息管理
            name: 'informationManage',
            component: () => import('@/views/main/informationManage/index'),
            meta: {
              title: '蜜仆-信息管理'
            },
          },
          {
            path: 'dynamicVocabulary',//信息管理
            name: 'dynamicVocabulary',
            component: () => import('@/views/main/dynamicVocabulary/index'),
            meta: {
              title: '蜜仆-信息管理'
            },
          },
          {
            path: 'forbiddenWord',//违禁词管理
            name: 'forbiddenWord',
            component: () => import('@/views/main/forbiddenWord/index'),
            meta: {
              title: '蜜仆-违禁词管理'
            },
          },
          {
            path: 'reportManage',//匿名举报
            name: 'reportManage',
            component: () => import('@/views/main/informationManage/report'),
            meta: {
              title: '蜜仆-匿名举报'
            },
          },
          {
            path: 'feedback',//意见反馈
            name: 'feedback',
            component: () => import('@/views/main/informationManage/feedback'),
            meta: {
              title: '蜜仆-意见反馈'
            },
          },
          {
            path: 'messages',//回复设置
            name: 'messages',
            component: () => import('@/views/main/informationManage/messages'),
            meta: {
              title: '蜜仆-回复设置'
            },
          },
          {
            path: 'promotionManage',//推广管理
            name: 'promotionManage',
            component: () => import('@/views/main/promotionManage/index'),
            meta: {
              title: '蜜仆-推广管理'
            },
          },
          {
            path: 'agency',//代理管理
            name: 'agency',
            component: () => import('@/views/main/promotionManage/agency'),
            meta: {
              title: '蜜仆-代理管理'
            },
          },
          {
            path: 'inviteManage',//邀请记录
            name: 'inviteManage',
            component: () => import('@/views/main/promotionManage/invite'),
            meta: {
              title: '蜜仆-邀请奖励管理'
            },
          },
          {
            path: 'intermediary',//中介管理
            name: 'intermediary',
            component: () => import('@/views/main/promotionManage/intermediary'),
            meta: {
              title: '蜜仆-中介管理'
            },
          },
          {
            path: 'shelves',//上架模式管理
            name: 'shelves',
            component: () => import('@/views/main/shelves/index'),
            meta: {
              title: '蜜仆-上架模式管理'
            },
          },
          ,
          {
            path: 'systemInforms',//系统通知
            name: 'systemInforms',
            component: () => import('@/views/main/systemInforms/index'),
            meta: {
              title: '蜜仆-系统通知'
            },
          },
          {
            path: 'agent',//代理管理
            name: 'agent',
            component: () => import('@/views/main/agent/index'),
            meta: {
              title: '蜜仆-代理管理'
            },
          },
          {
            path: 'agentUser',//人员管理
            name: 'agentUser',
            component: () => import('@/views/main/agent/user'),
            meta: {
              title: '蜜仆-代发人员管理'
            },
          },
          {
            path: 'agentTask',//代理任务
            name: 'agentTask',
            component: () => import('@/views/main/agent/task'),
            meta: {
              title: '蜜仆-代发任务管理'
            },
          },
          {
            path: 'agentTaskClaim',//代理任务
            name: 'agentTaskClaim',
            component: () => import('@/views/main/agent/taskClaim'),
            meta: {
              title: '蜜仆-代发任务审核'
            },
          },
          {
            path: 'agentWithdraw',//任务提现
            name: 'agentWithdraw',
            component: () => import('@/views/main/agent/withdraw'),
            meta: {
              title: '蜜仆-代发任务提现'
            },
          },
          {
            path: 'agentComment',//代发评论
            name: 'agentComment',
            component: () => import('@/views/main/agent/comment'),
            meta: {
              title: '蜜仆-代发评论'
            },
          },




























          
          {
            path: 'insuranceCompany',//保险公司
            name: 'insuranceCompany',
            component: () => import('@/views/main/insuranceCompany/index'),
            meta: {
              title: '蜜仆-保险公司'
            },
          },

          {
            path: 'dispatch',//保险公司
            name: 'dispatch',
            component: () => import('@/views/main/workOrder/dispatch'),
            meta: {
              title: '蜜仆-案件调度-调度'
            },
          },

        



          {
            path: '/roleLimits',//角色菜单管理
            name: 'roleLimits',
            component: () => import('@/views/main/base/roleLimits'),
            meta: {
              title: '蜜仆-角色菜单管理'
            },
          },
          {
            path: '/accountManagement',//账号管理
            name: 'accountManagement',
            component: () => import('@/views/main/base/accountManagement'),
            meta: {
              title: '蜜仆-账号管理'
            },
          },
          {
            path: '/menuManagement',//菜单管理
            name: 'menuManagement',
            component: () => import('@/views/main/base/menuManagement'),
            meta: {
              title: '蜜仆-菜单管理'
            },
          },
          {
            path: '/updatePassword',//编辑密码
            name: 'updatePassword',
            component: () => import('@/views/main/base/updatePassword'),
            meta: {
              title: '蜜仆-编辑密码'
            },
          },


         
          {
            path: '/organizationManage',//机构管理
            name: 'organizationManage',
            component: () => import('@/views/main/base/organizationManage'),
            meta: {
              title: '蜜仆-机构管理'
            },
          },
          {
            path: '/roleManage',//角色管理
            name: 'roleManage',
            component: () => import('@/views/main/base/roleManage'),
            meta: {
              title: '蜜仆-角色管理'
            },
          },
          // {
          //   path: '/userManage',//人员管理
          //   name: 'userManage',
          //   component: () => import('@/views/main/base/userManage'),
          //   meta: {
          //     title: '蜜仆-人员管理'
          //   },
          // },
          {
            path: '/audioManage',//人员管理
            name: 'audioManage',
            component: () => import('@/views/main/userManage/audio'),
            meta: {
              title: '蜜仆-人员管理'
            },
          },
          {
            path: '/videoManage',//视频管理
            name: 'videoManage',
            component: () => import('@/views/main/userManage/video'),
            meta: {
              title: '蜜仆-视频管理'
            },
          },
          {
            path: '/realImgManage',//视频管理
            name: 'realImgManage',
            component: () => import('@/views/main/userManage/realImg'),
            meta: {
              title: '蜜仆-真人图片'
            },
          },
          {
            path: '/chatList',//聊天管理
            name: 'chatList',
            component: () => import('@/views/main/chat/list'),
            meta: {
              title: '蜜仆-聊天管理'
            },
          },
          


         
        
         
         
          
         
         
          



          
        ]
          
        
      },

]